import { Modal, Upload, Input } from "antd";
import styled from "styled-components";
import { IoDocumentOutline, IoCloudUploadOutline } from "react-icons/io5";
import { FaRegTrashAlt } from "react-icons/fa";

const { Dragger } = Upload;

export const SendModal = styled(Modal)`
  .ant-modal-content {
    width: 498px;
    min-height: 464px;
    border-radius: 10px;
    max-width: 100%;
  }
  .ant-modal-footer {
    border-top: none;
    display: flex;
  }
`;

export const ModalTitle = styled.h1`
  width: 137;
  height: 32;

  font-family: Open Sans;
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 32px;
  color: rgba(68, 68, 68, 1);
`;

export const ModalBtnsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 10px;
  height: 35px;
`;

export const ModalActionBtns = styled.button`
  width: 221px;
  height: 100%;
  border-radius: 10px;
  font-family: Open Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0px 0.75px 1.5px 0px rgba(16, 24, 40, 0.05);
  background: ${({ $isCancel }) =>
    $isCancel ? "rgba(255, 255, 255, 1)" : "rgba(17, 167, 217, 1)"};
  color: ${({ $isCancel }) =>
    $isCancel ? "rgba(17, 167, 217, 1)" : "rgba(255, 255, 255, 1)"};
  border: ${({ $isCancel }) =>
    $isCancel ? "1px solid rgba(17, 167, 217, 1)" : "none"};

  transition: all 0.3s ease;

  &:hover {
    background: ${({ $isCancel }) =>
      $isCancel ? "rgba(240, 248, 255, 1)" : "rgba(15, 150, 195, 1)"};
    transform: translateY(-2px);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    pointer-events: none;
  }
`;
export const StyledDragger = styled(Dragger)`
  margin-top: 15px;
  background: rgba(255, 255, 255, 1) !important;
  width: 450px !important;
  height: 104px !important;
  border-radius: 10px !important;
  padding: 24px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;

  border: 1px dashed rgba(0, 0, 0, 0.25) !important;
  opacity: 1;
  cursor: pointer;

  .ant-upload-drag-icon {
    font-size: 24px;
  }

  .ant-upload-text,
  .ant-upload-hint {
    margin: 0;
  }

  /* Estilo do preview dos arquivos selecionados */
  .ant-upload-list-item {
    background: #f5f5f5; /* cor de fundo do preview */
    border-radius: 8px; /* cantos arredondados */
    padding: 8px 12px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border: 1px solid rgba(199, 201, 217, 1);
  }

  .ant-upload-list-item-name {
    font-size: 14px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
    border: 1px solid rgba(199, 201, 217, 1);
  }

  .ant-upload-list-item-actions {
    display: flex;
    gap: 8px;
    border: 1px solid rgba(199, 201, 217, 1);

    .anticon {
      font-size: 16px;
      color: #ff4d4f; /* cor do ícone de remover */
      cursor: pointer;
    }
  }
`;

export const UploadWrapper = styled.div`
  .ant-upload-drag {
    background: rgba(255, 255, 255, 1) !important;
    width: 450px !important;
    height: ${({ isPackage }) => (isPackage ? "54px" : "104px")} !important;
    border-radius: 10px !important;
    padding: 24px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: 1px dashed rgba(0, 0, 0, 0.25) !important;
    cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};
    opacity: ${({ $isDisabled }) => ($isDisabled ? 0.6 : 1)};
  }
`;

const UPLOADERS_SCROLL_MAX_HEIGHT = "440px";
const UPLOADERS_SCROLL_GAP = "16px";
const SCROLLBAR_WIDTH = "4px";
const SCROLLBAR_THUMB_COLOR = "#11a7d9";
const SCROLLBAR_TRACK_COLOR = "#fcfcfc";

export const UploadersScrollArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${UPLOADERS_SCROLL_GAP};
  max-height: ${UPLOADERS_SCROLL_MAX_HEIGHT};
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;

  ::-webkit-scrollbar {
    width: ${SCROLLBAR_WIDTH};
    height: 0;
    background-color: ${SCROLLBAR_TRACK_COLOR};
  }

  ::-webkit-scrollbar-thumb {
    background: ${SCROLLBAR_THUMB_COLOR};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-horizontal {
    display: none;
  }
`;

export const DraggerText = styled.p`
  font-family: Open Sans;
  font-size: 14px;
  color: rgb(141, 150, 161);
  font-weight: 400;
  text-align: center;
  font-style: Regular;
  line-height: 150%;
  letter-spacing: 0%;
  vertical-align: middle;
`;

export const FileNameSpan = styled.span`
  display: inline-block;
  width: 80%;
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  margin-left: 10px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ClickHere = styled.span`
  color: rgba(17, 167, 217, 1); // cor diferente
  text-decoration: underline;
  font-weight: 600;
  margin-right: 5px;
`;

export const ObsContainer = styled.div`
  margin-top: 24px;
`;

export const ObsInput = styled(Input.TextArea)`
  width: 450px;
  height: 113px;
  font-size: 14px;
  outline: none;

  .ant-input,
  .ant-input-textarea,
  textarea {
    border-radius: 8px !important;
    resize: none;

    &::-webkit-scrollbar {
      width: 8px;
      border-radius: 12px;
      background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
      background: #bdbdbd;
      border-radius: 12px;
    }
    &::-webkit-scrollbar-corner {
      background: #f1f1f1;
      border-radius: 12px;
    }
  }
`;

export const FileItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  margin-top: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: transparent;
  width: 450px;
  height: 57px;

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
export const FileItemContent = styled.div`
  display: flex;
  align-items: center;
  width: 80%;
`;
export const FileIcon = styled(IoDocumentOutline)`
  cursor: pointer;
  color: rgba(17, 167, 217, 1);
  font-size: 18px;
`;

export const DeleteIcon = styled(FaRegTrashAlt)`
  cursor: pointer;
  color: red;
  font-size: 16px;
`;
export const UploadIcon = styled(IoCloudUploadOutline)`
  color: rgba(144, 161, 185, 1);
  font-size: 24px;
`;
export const ErrorText = styled.span`
  color: red;
  font-size: 12px;
  margin-top: 4px;
  display: block;
`;

export const ExtensionInformation = styled.p`
  color: #676f82;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: justify;
  text-justify: inter-word;
  margin: 0;
`;

export const NotesOptional = styled.span`
  color: #999999;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;
